'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = HotelName;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _emailStyleTools = require('helpers/emailStyleTools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HotelName(props) {
  var components = props.components,
      name = props.name;

  var styleHotelNameContainer = (0, _emailStyleTools.containerStyles)(components, 'HotelNameContainer');
  var styleHotelNameLabel = (0, _emailStyleTools.textStyles)(components, 'HotelNameLabel');

  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'HotelHeader' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, styleHotelNameContainer, _emailStyleTools.padTen) },
          _react2.default.createElement(
            'span',
            { style: styleHotelNameLabel },
            name
          )
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Hotel/Email/Active/HotelName.jsx
// module id = 1522
// module chunks = 0